import axios from 'axios'
import { useUserStore } from '@/stores/user'
import { ElMessage } from 'element-plus'
import router from '@/router'

const service = axios.create({
  baseURL: import.meta.env.VITE_API,
  timeout: 20 * 1000,
})

service.interceptors.request.use(
  async (config) => {
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

//响应拦截器
service.interceptors.response.use(
  async (response: any) => {

    return response.data
  },
  (error) => {
    const { status, response } = error
    const { data } = response
    const { message } = data

    ElMessage.error(message)

    if (status === 401) {
      const userStore = useUserStore()
      userStore.setIsLogin(false)
    }




    if (error?.message === 'canceled') return Promise.reject(error || 'error')
    return Promise.reject(error || 'error')
  },
)

export default service
